import { render, staticRenderFns } from "./CompanyAttendance.vue?vue&type=template&id=8141afd0&scoped=true"
import script from "./CompanyAttendance.vue?vue&type=script&lang=js"
export * from "./CompanyAttendance.vue?vue&type=script&lang=js"
import style0 from "./CompanyAttendance.vue?vue&type=style&index=0&id=8141afd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8141afd0",
  null
  
)

export default component.exports